<template>
  <div class="qn-advance-nps">
    <ul class="qn-nps-container">
      <li
        v-for="(nps, index) in npsTotal"
        :key="index"
        class="qn-nps-item"
        :class="curNps === nps.value ? 'active' : ''"
        @click.stop="chooseNps(nps.value)"
      >{{ nps.label }}</li>
    </ul>
    <span class="qn-nps-item-left-desc">{{ $attrs.leftDesc || '不可能' }}</span>
    <span class="qn-nps-item-right-desc">{{ $attrs.rightDesc || '极有可能' }}</span>
  </div>
</template>
<script>
export default {
  data () {
    return {
      curNps: undefined
    }
  },
  computed: {
    npsTotal () {
      return this.$attrs?.topicData?.collect || 10
    }
  },
  mounted () {
    this.curNps = this.$attrs.__config__.defaultValue
  },
  methods: {
    chooseNps (num) {
      this.curNps = num
      this.$emit('chooseNpsData', num)
    }
  }
}
</script>
<style lang="stylus" scoped>
.qn-advance-nps
  padding 10 0
  .qn-nps-container
    margin-bottom 12px
    display flex
    align-items center
    justify-content space-between
    font-size 14px
    line-height 22px
    padding-left 0
    .qn-nps-item
      list-style none
      box-sizing border-box
      padding 6px
      border-radius 2px
      background #f5f6f7
      flex-grow 1
      margin 0 4px
      text-align center
      cursor pointer
      &:first-child
        margin-left 0
      &:last-child
        margin-right 0
    .active
      background #3370ff
      color #fff
  .qn-nps-item-right-desc
    float right
</style>